<template>
  <button class="owc-footer-movetotop" @click="handleButtonEvents">
    <wb-icon class="owc-footer-movetotop__icon" name="bds/chevron-up/24" />
    <span class="owc-footer-movetotop__subtitle">{{ text }}</span>
  </button>
</template>

<script lang="ts">
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { componentMode } from './Footer.config';
import { MoveToTopData, MoveToTopMethods, MoveToTopComputed, MoveToTopProps } from './MoveToTop';
/**
 * `Move To Top Footer` - Move To Top Footer for OneWeb - This component allows the user to navigate to the top of the page if the component is clicked
 */

export default ComponentInitializeDispatcher.extend<
  MoveToTopData,
  MoveToTopMethods,
  MoveToTopComputed,
  MoveToTopProps
>({
  name: 'owc-move-to-top',
  props: {
    moveToTop: {
      type: Object,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
    text: function(): string {
      return this.isEdit ? this.componentData?.text : this.moveToTop?.text;
    },
  },
  methods: {
    scrollToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    handleButtonEvents() {
      this.scrollToTop();
      this.handleCustomTracking(this.$el, 'move_to_top', 'feature', 'click', 'feature');
    },
  },
});
</script>

<style lang="scss">
$moveToTopModuleName: 'owc-footer-movetotop';

.#{$moveToTopModuleName} {
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  margin: var(--wb-spacing-s) 0;
  padding: 0;

  border: 0;

  color: var(--wb-white);

  background: transparent;

  cursor: pointer;

  &__icon {
    width: 48px;
    height: 48px;

    margin-bottom: var(--wb-spacing-xxs);
  }
  &__subtitle {
    @include wb-type-copy-secondary;
  }
}
</style>
